function App() {
  if (!$) {
    window.$ = jQuery
  }

  const header = $('.js-header')
  const headerHeight = header.height()

  function initHeader() {
    if ($(window).scrollTop() > headerHeight) {
      header.addClass('fixed')
    } else {
      header.removeClass('fixed')
    }
  }

  $('.js-burger').on('click', function () {
    $('body').toggleClass('menu-open')
  })

  // initial main video
  function initMainVideo() {
    const video = $('.js-main-video')
    const videoUI = $('.js-video-ui')
    const progressBarInner = $('.js-progress-bar-inner')
    const playPauseBtn = $('.js-play-pause-btn')
    
    playPauseBtn.on('click', function() {
      const videoId = videoUI.data('video')
      const targetVideo = document.getElementById(videoId)
      
      if (targetVideo.paused) {
        targetVideo.play()
        videoUI.removeClass('paused')
        videoUI.addClass('playing')
      } else {
        targetVideo.pause()
        videoUI.removeClass('playing')
        videoUI.addClass('paused')
      }
    })
    
    video.on('timeupdate', function () {
      const currentTime = this.currentTime
      const duration = this.duration
      const progress = (currentTime / duration) * 100
      progressBarInner.css('width', progress + '%')
    })
    
    $('.progress-bar').on('click', function(e) {
      const videoId = videoUI.data('video')
      const targetVideo = document.getElementById(videoId)
      const rect = this.getBoundingClientRect()
      const clickX = e.clientX - rect.left
      const width = rect.width
      const clickPercent = clickX / width
      const newTime = clickPercent * targetVideo.duration
      
      targetVideo.currentTime = newTime
    })
    
    video.on('play', function () {
      videoUI.addClass('playing')
      videoUI.removeClass('paused')
    })

    video.on('pause', function () {
      videoUI.removeClass('playing')
      videoUI.addClass('paused')
    })
  }

  // Initialize brand slider
  function initBrandSlider() {
    document.querySelectorAll('.js-brand-slider').forEach(function (slider) {
      new Splide(slider, {
        type: 'loop',
        drag: 'false',
        focus: 'right',
        autoWidth: true,
        arrows: false,
        pagination: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
          pauseOnFocus: false,
          drag: 'false',
        },
        breakpoints: {
          768: {
            autoScroll: {
              speed: 1,
            },
          },
        },
      }).mount(window.splide.Extensions)
    })
  }

  function initLogoSliders() {
    document.querySelectorAll('.js-logo-slider-top').forEach(function (slider) {
      new Splide(slider, {
        type: 'loop',
        drag: 'false',
        focus: 'right',
        arrows: false,
        pagination: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        autoWidth: true,
        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount(window.splide.Extensions)
    })

    document.querySelectorAll('.js-logo-slider-bottom').forEach(function (slider) {
      new Splide(slider, {
        type: 'loop',
        drag: 'false',
        focus: 'right',
        direction: 'rtl',
        arrows: false,
        pagination: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        autoWidth: true,
        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount(window.splide.Extensions)
    })
  }

  function initPortfolioSlider() {
    $('.js-portfolio-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      variableWidth: true,
      centerPadding: '32px',
      centerMode: true,
    })

    initPerNextSlides();

    function initPerNextSlides() {
      $('.js-portfolio-slider .slick-slide').removeClass('per-slide next-slide per-per-slide next-next-slide');
      
      const centerSlide = $('.js-portfolio-slider .slick-current');
      
      centerSlide.prev().addClass('per-slide');
      
      centerSlide.next().addClass('next-slide');
    } 
    $('.js-portfolio-slider').on('afterChange', function(event, slick, currentSlide) {
      initPerNextSlides()
    })
  }

  $('.js-copyright').text(new Date().getFullYear())

  document.addEventListener('scroll', function() {
    initHeader()
  })

  initHeader()
  initMainVideo()
  initBrandSlider()
  initPortfolioSlider()
  initLogoSliders()
}

App()
